import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const MUTUACORE_API_URL = process.env.REACT_APP_MUTUACORE_API_URL || 'https://sso.mutuacore.fr';

function MotDePasseOublie() {
  const [email, setEmail] = useState('');
  const [envoye, setEnvoye] = useState(false);
  const [chargement, setChargement] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setChargement(true);

    try {
      await fetch(`${MUTUACORE_API_URL}/email/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, produit: 'auditcyberpro' })
      });

      // Le backend renvoie toujours 200, qu'un compte existe ou non
      // (on ne révèle jamais si un email est enregistré ou pas)
      setEnvoye(true);
    } catch (err) {
      console.error('Erreur demande réinitialisation:', err);
      setError('Erreur de connexion au serveur sécurisé. Veuillez réessayer.');
    } finally {
      setChargement(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ecf0f1', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ color: '#2c3e50', margin: '0 0 10px 0' }}>Audit Cyber Pro</h2>
          <p style={{ color: '#7f8c8d', margin: 0 }}>Mot de passe oublié</p>
        </div>

        {error && (
          <div style={{ background: '#e74c3c', color: 'white', padding: '10px', borderRadius: '5px', marginBottom: '20px', textAlign: 'center', fontSize: '14px' }}>
            {error}
          </div>
        )}

        {envoye ? (
          <div>
            <div style={{ background: '#2ecc71', color: 'white', padding: '15px', borderRadius: '5px', marginBottom: '20px', textAlign: 'center', fontSize: '14px' }}>
              Si un compte existe avec cet email, un lien de réinitialisation vient de vous être envoyé. Vérifiez votre boîte de réception (et vos spams).
            </div>
            <p style={{ textAlign: 'center', fontSize: '14px' }}>
              <Link to="/login" style={{ color: '#3498db', textDecoration: 'none', fontWeight: 'bold' }}>Retour à la connexion</Link>
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: '#7f8c8d', fontSize: '14px', marginBottom: '20px' }}>
              Saisissez l'email associé à votre compte, nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>

            <div style={{ marginBottom: '30px' }}>
              <label style={{ display: 'block', marginBottom: '5px', color: '#34495e', fontWeight: 'bold' }}>Email professionnel</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc', boxSizing: 'border-box' }}
                placeholder="contact@entreprise.com"
              />
            </div>

            <button
              type="submit"
              disabled={chargement}
              style={{ width: '100%', padding: '12px', background: '#2c3e50', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', fontSize: '16px', cursor: chargement ? 'not-allowed' : 'pointer', opacity: chargement ? 0.7 : 1 }}
            >
              {chargement ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
            </button>

            <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px', color: '#7f8c8d' }}>
              <Link to="/login" style={{ color: '#3498db', textDecoration: 'none', fontWeight: 'bold' }}>Retour à la connexion</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}

export default MotDePasseOublie;